var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookInsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.838,
    height: 18.547,
    viewBox: "0 0 21.838 18.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -36.671)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 36.671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33,305.158v3.54a.4.4,0,0,0,.395.395h2.737a.4.4,0,0,0,.395-.395v-6.227l-1.988,1.988A2.411,2.411,0,0,1,33,305.158Z",
    transform: "translate(-31.519 -290.546)",
    fill: "#112c5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,301.471v6.272a.4.4,0,0,0,.395.395h2.737a.4.4,0,0,0,.395-.395v-3.692a2.386,2.386,0,0,1-1.647-.7Z",
    transform: "translate(-135.629 -289.591)",
    fill: "#112c5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,276.821V280.9a.4.4,0,0,0,.395.395h2.737a.4.4,0,0,0,.395-.395v-7.533l-3.136,3.136A2.351,2.351,0,0,1,251,276.821Z",
    transform: "translate(-239.739 -262.751)",
    fill: "#112c5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.262,170.171,360,173.433v8.9a.4.4,0,0,0,.395.395h2.737a.4.4,0,0,0,.395-.395V170.418c-.09-.076-.157-.144-.206-.188Z",
    transform: "translate(-343.849 -164.182)",
    fill: "#112c5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.652,36.882a.763.763,0,0,0-.579-.211H21c-1.274.058-2.544.121-3.818.179a.824.824,0,0,0-.588.2.669.669,0,0,0-.139.206.66.66,0,0,0,.2.8l.319.323c.22.224.444.449.668.668l-7.7,7.7L6.487,43.293a1.1,1.1,0,0,0-1.557,0L.323,47.9a1.1,1.1,0,0,0,0,1.557l.206.206a1.1,1.1,0,0,0,1.557,0l3.621-3.621L9.166,49.5a1.1,1.1,0,0,0,1.561,0l8.686-8.686.983.978a.744.744,0,0,0,.525.278.649.649,0,0,0,.314-.085.855.855,0,0,0,.188-.139.912.912,0,0,0,.238-.633c.036-.826.076-1.651.117-2.481l.058-1.243A.772.772,0,0,0,21.652,36.882Z",
    transform: "translate(0 -36.671)",
    fill: "#112c5a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookInsight);
export default __webpack_public_path__ + "static/media/facebook-insight.12930f496e5ffe7a09c7d9df626ba3c1.svg";
export { ForwardRef as ReactComponent };